module.exports = __webpack_public_path__ + "img/ubuntu22.b598ee3.svg";